<template>
    <div>
        <p>{{ answer }}</p>
    </div>
</template>

<script>
export default {
    name: "check-question",
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        answer() {
            let answers = [];

            let options = this.getOptionsAnswer();
            if (options !== null) {
                answers.push(options);
            }

            let customOptions = this.getCustomOptions();
            if (customOptions !== null) {
                answers.push(customOptions);
            }

            let otherOption = this.question.answer["other-checked-option"];
            if (otherOption !== null) {
                answers.push(otherOption.text);
            }

            let answer = answers.join(", ");
            return answer ?? "-";
        },
    },
    methods: {
        getOptionsAnswer() {
            let options = [];

            this.question.answer["checked-options"].forEach((o) => {
                let option = this.question.options.find(
                    (opt) => opt.id === o.optionId
                );
                options.push(option.text);
            });

            return options.length > 0 ? options.join(", ") : null;
        },
        getCustomOptions() {
            let options = [];

            this.question.answer["custom-checked-options"].forEach((o) => {
                options.push(o.text);
            });

            return options.length > 0 ? options.join(", ") : null;
        },
    },
};
</script>